if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.stickyAnnouncement = this.dataset.sticky;
      this.handleSticky();

      const enableSlider = this.dataset.enableSlider === "true";
      if (enableSlider) {
        this.initSlider();
      }
    }

    handleSticky() {
      if (this.stickyAnnouncement === "none" || !this.stickyAnnouncement) return;

      if (this.stickyAnnouncement === "always") {
        this.classList.add("announcement-sticky-always");
        return;
      }

      // For "on_scroll_up"
      let lastScroll = 0;
      const threshold = 100; // scroll threshold to start sticking

      window.addEventListener("scroll", () => {
        const currentScroll = window.scrollY;

        if (currentScroll <= threshold) {
          this.classList.remove("stuck", "scroll-up", "scroll-down");
          return;
        }

        this.classList.add("stuck");

        if (currentScroll > lastScroll) {
          // Scrolling down
          this.classList.remove("scroll-up");
          this.classList.add("scroll-down");
        } else {
          // Scrolling up
          this.classList.remove("scroll-down");
          this.classList.add("scroll-up");
        }

        lastScroll = currentScroll;
      });
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}
